<template>
  <div
    v-if="hasBanner"
    class="single-banner-container"
    :style="`background-color:${backgroundColor}`"
  >
    <SingleBannerItem :banner-info="bannerInfo" />
  </div>
</template>
<script setup>
  import { ref, computed, defineProps } from 'vue'
  import { convertBand } from '@/common/converter/convert-band'
  import SingleBannerItem from '@/components/section/template/banner/SingleBannerItem'

  const props = defineProps({
    catalogInfo: {
      type: Object,
      default: null,
    },
    sectionInfo: {
      type: Object,
      default: null,
    },
  })

  const bannerInfo = ref(null)
  const backgroundColor = ref('')
  const hasBanner = computed(() => bannerInfo.value !== null)

  const setData = async () => {
    try {
      const bandInfo = await convertBand(props.catalogInfo)
      bannerInfo.value = bandInfo?.band?.celllist?.[0] ?? null
      backgroundColor.value = bandInfo?.note ?? null
    } catch (error) {
      console.error(error)
    }
  }

  setData()
</script>

<style scoped>
  .single-banner-container {
    width: 100%;
    margin: 10px 0;
  }
</style>
